import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { includes, map } from 'lodash';
import { ReportTypes } from '../constants';
import './style.scss';

// NOTE: This is a static UI component. Backend is still in development.
// TODO: Check backend API keys and wire selectedTypes into the API request payload
//       once the backend endpoint for Report Type filtering is available.

const GatewayEventReportTypeFilter = ({
    selectedTypes,
    onSelectType,
    disabled = false
}) => {
    const { t: translate } = useTranslation();

    return (
        <div className='event-type-filter'>
            <div className='event-types'>
                {map(ReportTypes, (reportType) => {
                    const isSelected = includes(selectedTypes || [], reportType.typeID);
                    const label = translate(reportType.label);
                    return (
                        <button
                            key={reportType.typeID}
                            className={`event-type event-type-label${isSelected ? ' selected' : ''}`}
                            onClick={() => !disabled && onSelectType(reportType.typeID)}
                            disabled={disabled}
                        >
                            {label}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

GatewayEventReportTypeFilter.propTypes = {
    selectedTypes: PropTypes.array,
    onSelectType: PropTypes.func.isRequired,
    disabled: PropTypes.bool
};

export default GatewayEventReportTypeFilter;
